var map = {
	"./bh-ico.svg": 625,
	"./bonus-ico.svg": 626,
	"./deposit-ico.svg": 627,
	"./deposit-ico.webp": 1677,
	"./edit-icon.svg": 628,
	"./fb-ico.svg": 629,
	"./mall-ico.svg": 630,
	"./msg-ico.svg": 631,
	"./pi-ico.svg": 632,
	"./rf-ico.svg": 633,
	"./rh-ico.svg": 634,
	"./th-ico.svg": 635,
	"./vip-ico.svg": 636,
	"./withdrawal-ico.svg": 637,
	"./withdrawal-ico.webp": 1678,
	"./wl-ico.svg": 638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1676;